import React, { useEffect, useMemo, useRef } from "react";
import Swal from "sweetalert2";
import { showPmrSuccess } from "../utils/swalUtils";

let activeSuccessModalKey = null;

export default function CustomSuccessModal({ show, onHide, message, name }) {
  const onHideRef = useRef(onHide);
  const modalKey = useMemo(() => `${name || ""}|${message || ""}`, [message, name]);

  useEffect(() => {
    onHideRef.current = onHide;
  }, [onHide]);

  useEffect(() => {
    if (show) {
      if (activeSuccessModalKey === modalKey && Swal.isVisible()) {
        return;
      }

      activeSuccessModalKey = modalKey;

      const nameHtml = name !== "" && name !== undefined
        ? `<div style="color:var(--pmr-text-heading);font-size:18px;font-weight:600;">${name}</div>`
        : "";

      showPmrSuccess({
        html: `${nameHtml}<div style="color:var(--pmr-text);font-size:16px;text-align:center;">${message || ''}</div>`,
        timer: 2000,
      }).then(() => {
        if (activeSuccessModalKey === modalKey) {
          activeSuccessModalKey = null;
        }
        if (onHideRef.current) onHideRef.current();
      });
    }
  }, [show, message, name, modalKey]);

  return null;
}
